import React, { useEffect, useState } from "react";
import './AppointmentPage.css'
import { Spin } from "antd"; // Import Spin from antd
import { ArrowLeftOutlined, ArrowRightOutlined, DownOutlined } from "@ant-design/icons";
import Appointmenttype from "../Dashboard/Appointmenttype";
import axios from "axios";
import Hbooking from "../Healthjourney/Hbooking";
import { useNavigate } from "react-router-dom";

const UnifiedAppointmentType = ({onNext,onBack,productCategoryId,productId}) => {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);
    const [getAllHealthScreenData, setGetAllHealthScreenData] = useState(null);
    const [sendingData, setsendingData] = useState({
        non_gp_product_id: "",
        productCategory: {
            title: "Health Screen"
        },
        isback: onBack
    });
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true); // Add loading state

    const callbackAppointment = (data, formType) => {
        const sanitizedData = {
            ...data,
            productCategory: {
                ...data.productCategory,
                icon: undefined
            }
        };

        if(data.productCategory.key === "gp"){
            onNext();
        } else if (data.productCategory.key === "health"){
            setCurrentStep(2);
            var a = data;
            a.isback = () => { setCurrentStep(1); console.log("Back button clicked for health journey") };
            setsendingData(a);
        }
    };

    const iconMap = {
        1: <ArrowRightOutlined />,
        2: <DownOutlined />,
    };



    useEffect(() => {
        window.scrollTo(0, 0);
        const fetchData = async () => {
            try {
                setLoading(true);
                
                // Fetch both data sources in parallel
                const [healthScreenRes, optionsRes] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_BASE_URLOPEN}non-gp-products`, {
                        headers: { "Content-Type": "application/json" },
                        params: { category: "clinician_type" }
                    }),
                    fetch(`${process.env.REACT_APP_BASE_URLOPEN}product-category/page/1`)
                ]);

                // Process health screen data
                const healthScreenData = healthScreenRes.data.data || [];
                const formattedData = {
                    getAllHealthScreenData: {
                        getAllHealthScreenData: { data: healthScreenData },
                        allGPproduct: []
                    },
                    ContinueButoonStylingMiddle: true
                };

                const productMap = {};
                healthScreenData.forEach(product => {
                    productMap[product.non_gp_product_id] = product.name;
                });
                localStorage.setItem('nongroupproductid', JSON.stringify(productMap));
                setGetAllHealthScreenData(formattedData);

                // Process options data
                const optionsData = await optionsRes.json();
                const categories = optionsData.data.data;
                const dynamicOptions = categories.map((cat) => ({
                    key: cat.name.toLowerCase().includes("gp") ? "gp" :
                        cat.name.toLowerCase().includes("health") ? "health" :
                        `cat-${cat.product_category_id}`,
                    title: cat.name,
                    product_category_id: cat.product_category_id,
                    description: cat.description ,
                    icon: iconMap[cat.product_category_id] || <ArrowRightOutlined />,
                }));

                const manualOption = {
                    key: "video",
                    title: "Video Consultations",
                    product_category_id: 3,
                    description: "",
                    icon: <ArrowRightOutlined />,
                };

                setOptions([...dynamicOptions, manualOption]);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

    }, []);

    if (loading) {
        return (
            <div className="page-wrapper">
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <Spin size="large" className="custom-spinner" />
                </div>
            </div>
        );
    }

    return (
        <div className="page-wrapper">
            <main className="main">
                {currentStep === 1 && getAllHealthScreenData && options.length > 0 && (
                    <Appointmenttype
                        {...getAllHealthScreenData}
                        callback={callbackAppointment}
                        callBackForbackpage={() => console.log("Back button clicked")}
                        options={options}
                        productCategoryId={productCategoryId}
                        productId={productId}
                    />
                )}
                {currentStep === 2 && <Hbooking data={sendingData}/>}
            </main>
        </div>
    );
};

export default UnifiedAppointmentType;